<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             top='10vh' @close='dialogClose' width='1050px'>
      <div-border label='委托车列表' class='p20'>
        <el-table
          v-if="this.type === 0"
          ref='searchTable'
          row-key='id'
          v-loading='tableLoading'
          :data='tableData'
          style='width: 100%'
          border
          sizi='mini'
          :header-cell-style='headerCellStyle'>
          <el-table-column label='批次号' prop='batchNumberY' align='center' width='140' />
          <el-table-column label='新批次号（批次号发生更改时填写' prop='batchNumber' align='center' width='180' />
          <el-table-column label='运单号' prop='waybillNoY' align='center' width='140' show-overflow-tooltip/>
          <el-table-column label='新运单号（运单号发生更改时填写）' prop='waybillNo' align='center' width='140' show-overflow-tooltip />
          <el-table-column label='车架号' prop='frameNumberY' align='center' width='180' />
          <el-table-column label='新车架号（车架号发生更改时填写）' prop='frameNumber' align='center' width='180' />
          <el-table-column label='委托商' prop='consignorName' align='center' width='180' show-overflow-tooltip/>
          <el-table-column label='原委托商' prop='consignorNameY' align='center' width='180' show-overflow-tooltip/>
          <el-table-column label='运输条款' prop='transRulesType' align='center' width='120' />
          <el-table-column label='原运输条款' prop='transRulesTypeY' align='center' width='120' />
<!--          <el-table-column label='运输方式' prop='transportMode' align='center'-->
<!--                           :formatter='transportModeFormat' />-->
<!--          <el-table-column label='原运输方式' prop='transportModeY' align='center'-->
<!--                           :formatter='transportModeFormat' />-->
          <el-table-column label='提车场点' prop='pickCar' align='center' width='180' />
          <el-table-column label='原提车场点' prop='pickCarY' align='center' width='180' />
          <el-table-column label='起运地' prop='departurePlace' align='center' width='180' />
          <el-table-column label='原起运地' prop='departurePlaceY' align='center' width='180' />
          <el-table-column label='起运港' prop='departurePort' align='center' width='180' />
          <el-table-column label='原起运港' prop='departurePortY' align='center' width='180' />
          <el-table-column label='目的港' prop='arrivePort' align='center' width='180' />
          <el-table-column label='原目的港' prop='arrivePortY' align='center' width='180' />
          <el-table-column label='目的地' prop='arrivePlace' align='center' width='180' />
          <el-table-column label='原目的地' prop='arrivePlaceY' align='center' width='180' />
          <el-table-column label='收车单位(原经销商)' prop='collectCar' align='center' width='180' />
          <el-table-column label='原收车单位(原经销商)' prop='collectCarY' align='center' width='180' />
          <el-table-column label='品牌' prop='brandName' align='center' width='180' />
          <el-table-column label='原品牌' prop='brandNameY' align='center' width='180' />
          <el-table-column label='型号' prop='modelName' align='center' width='180' />
          <el-table-column label='原型号' prop='modelNameY' align='center' width='180' />
          <el-table-column label='计划类型' prop='planTypeName' align='center' width='180' />
          <el-table-column label='原计划类型' prop='planTypeNameY' align='center' width='180' />
          <el-table-column label='计划时间 ' prop='planTime' align='center' width='180' />
          <el-table-column label='原计划时间 ' prop='planTimeY' align='center' width='180' />
          <el-table-column label='回单类型' prop='receiptType' align='center' width='180'
                           :formatter="receiptTypeFormat"/>
          <el-table-column label='原回单类型' prop='receiptTypeY' align='center' width='180'
                           :formatter="receiptTypeFormat"/>
<!--          <el-table-column label='备注' prop='arrivePlace' align='center' width='180' />-->
<!--          <el-table-column label='原备注' prop='arrivePlaceY' align='center' width='180' />-->
        </el-table>
        <el-table
          v-else
          ref='searchTable'
          row-key='id'
          v-loading='tableLoading'
          :data='tableList'
          style='width: 100%'
          border
          sizi='mini'
          :header-cell-style='headerCellStyle'>
          <el-table-column label='批次号' prop='batchNumber' align='center' width='140' show-overflow-tooltip/>
          <el-table-column label='原批次号' prop='batchNumberY' align='center' width='140' show-overflow-tooltip/>
          <el-table-column label='运单号' prop='billNumber' align='center' width='140' show-overflow-tooltip/>
          <el-table-column label='原运单号' prop='billNumberY' align='center' width='140' show-overflow-tooltip/>
          <el-table-column label='车架号' prop='frameNumber' align='center' width='180' />
          <el-table-column label='原车架号' prop='frameNumberY' align='center' width='180' />
          <el-table-column label='变更路段' prop='changeLine' align='center' width='140' show-overflow-tooltip/>
          <el-table-column label='原变更路段' prop='changeLineY' align='center' width='140' show-overflow-tooltip/>
<!--          <el-table-column label='运输方式(车或船舶)' prop='type' align='center' width='140'-->
<!--                           :formatter="typeFormat"/>-->
<!--          <el-table-column label='原运输方式(车或船舶)' prop='typeY' align='center' width='150'-->
<!--                           :formatter="typeFormat"/>-->
          <el-table-column label='装车时间' prop='loadingDate' align='center' width='120' show-overflow-tooltip/>
          <el-table-column label='原装车时间' prop='loadingDateY' align='center' width='120' show-overflow-tooltip/>
          <el-table-column label='交车时间' prop='deliveryDate' align='center' width='120' show-overflow-tooltip/>
          <el-table-column label='原交车时间' prop='deliveryDateY' align='center' width='120' show-overflow-tooltip/>
          <el-table-column label='供应商类型' prop='supplierType' align='center' width='120'/>
          <el-table-column label='原供应商类型' prop='supplierTypeY' align='center' width='120'/>
          <el-table-column label='供应商' prop='supplierName' align='center' width='180' show-overflow-tooltip/>
          <el-table-column label='原供应商' prop='supplierNameY' align='center' width='180' show-overflow-tooltip/>
          <el-table-column label='装车地' prop='arrivePlace' align='center' width='120' />
          <el-table-column label='原装车地' prop='arrivePlaceY' align='center' width='120' />
          <el-table-column label='装车港口' prop='startName' align='center' width='120' />
          <el-table-column label='原装车港口' prop='startNameY' align='center' width='120' />
          <el-table-column label='交车地' prop='arrivePlace' align='center' width='180' />
          <el-table-column label='原交车地' prop='arrivePlaceY' align='center' width='180' />
          <el-table-column label='交车港口' prop='arrivePlace' align='center' width='180' />
          <el-table-column label='原交车港口' prop='arrivePlaceY' align='center' width='180' />
        </el-table>
      </div-border>
  </el-dialog>
</template>

<script>
import divBorder from '@/components/divBorder.vue';
import {getDetail2} from "@/service/vehiclelog";

export default {
  name: 'supplierDeliveryInfo',
  components: { divBorder },
  data() {
    return {
      dialogTitle: '变更详情',
      dialogVisible: false,
      tableLoading: false,
      tableData: [],
      tableList: [],
      total: 0,
      type:'',
      headerCellStyle: {
        'color': '#3B3B3B',
        'font-size': '13px',
        'height': '48px',
        'background': '#E8E8E8',
      },
      formLoading: false,
    };
  },
  filters: {
    typeFormat(value){
      switch (value) {
        case 0:
          return "运输计划变更";
        case 1:
          return "实际运输变更";
      }
    },
  },
  methods: {
    transportModeFormat(r, c, cellValue) {
      switch (cellValue) {
        case '1':
          return '公路';
        case '2':
          return '水路';
        case '3':
          return '水陆联运';
      }
    },
    typeFormat(r, c, cellValue) {
      switch (cellValue) {
        case 0:
          return '车';
        case 1:
          return '船舶';
      }
    },
    receiptTypeFormat(r, c, cellValue) {
      switch (cellValue) {
        case '1':
          return '电子回单';
        case '2':
          return '纸质回单';
      }
    },
    dialogOpen(row) {
      this.type = row.bgType
      this.dialogVisible = true;
      this.getDetailData(row.id);
    },
    // 查询
    searchBtn() {
      this.searchForm.page = 1;
      this.getDetailData();
    },
    //获取数据
    async getDetailData(id) {
      this.tableLoading = true;
      const {
        status,
        message,
        data,
      } = await getDetail2(id);
      this.tableLoading = false;
      if (status !== null) return this.$message.warning(message);
      if(this.type === 1){
        this.tableList = data.actualChangeList;
      }else {
        this.tableData = data.changePlanList;
      }
      this.total = data.total;
    },
    detailSizeChange(row) {
      this.searchForm.rows = row;
      this.searchForm.page = 1;
      this.getDetailData();
    },
    detailCurrentChange(page) {
      this.searchForm.page = page;
      this.getDetailData();
    },
    dialogClose() {
      this.dialogVisible = false;
    },
  }
};
</script>

<style lang='scss' scoped></style>
